"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeepDecode = void 0;
var _entities = require("entities");
var _cloneDeepWith = _interopRequireDefault(require("es-toolkit/compat/cloneDeepWith"));
var _react = require("react");
const useDeepDecode = input => (0, _react.useMemo)(() => (0, _cloneDeepWith.default)(input, value => {
  if (typeof value === 'string') {
    return (0, _entities.decodeHTML)(value);
  }

  // Returning undefined tells cloneDeepWith to fall back to its default cloning behavior
  return undefined;
}), [input]);
exports.useDeepDecode = useDeepDecode;
